import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/components/common/messageservice';
import { Observable } from 'rxjs';
import { ArquivoService } from '../../shared/services/arquivo.service';
import { WebPage } from '../../shared/web-page';
import { CfcService } from '../cfc.service';

@Component({
  selector: 'sispac-cadastrar-termo-aditivo-cfc',
  templateUrl: './cadastrar-termo-aditivo-cfc.component.html',
  styleUrls: ['./cadastrar-termo-aditivo-cfc.component.css']
})
export class CadastrarTermoAditivoCfcComponent  extends WebPage {

  private formTermoAditivoPrestador: FormGroup;
  private arquivosToRemove = new FormArray([]);
  public uploadUrl: string;
  public cfcUnidade:any;
  public cfcTermoAditivo;
  public tiposTermos:any;

  private edicao:boolean;

  get idTipoTermoAditivoPrestadorServico() { return this.formTermoAditivoPrestador.get('idTipoTermoAditivoPrestadorServico'); }
  get dataAssinatura() { return this.formTermoAditivoPrestador.get('dataAssinatura'); }
  get dataValidade() { return this.formTermoAditivoPrestador.get('dataValidade'); }
  get numeroProcesso() { return this.formTermoAditivoPrestador.get('numeroProcesso'); }
  get arquivos() { return this.formTermoAditivoPrestador.get('arquivos') as FormArray; }

  getControl(field) { return this.formTermoAditivoPrestador.get(field); }

  constructor(
    private fb: FormBuilder,
    public messageService: MessageService,
    private route: ActivatedRoute,
    private arquivoService: ArquivoService,
    private cfcService: CfcService,
    private router: Router,
  ){

    super(messageService);

    this.route.paramMap
      .subscribe(params => {
        this.inicializarFormularioTermoAditivoPrestador(params.get('idCfcUnidade'));
        this.edicao = false;
        if(params.has("idCfcTermoAditivo")){
          this.cfcTermoAditivo = params.get('idCfcTermoAditivo');
          this.edicao = true;
        }
      });

    this.uploadUrl = this.arquivoService.uploadUrl + 'termoAditivoPrestadorServico';

  }

  ngOnInit(){
    this.popularFormularioTermoAditivoPrestadorParaEdicao(this.cfcTermoAditivo);
    this.getTiposTermos();
  }

  getTiposTermos(){
    this.cfcService.getTiposTermo().subscribe(
      response => {
        this.tiposTermos = response;
    });
  }

  popularFormularioTermoAditivoPrestadorParaEdicao(idCfcTermoAditivo){

    this.cfcService.getTermoAditivo(idCfcTermoAditivo).subscribe(
      response => {

        this.formTermoAditivoPrestador.patchValue({
          idCfcTermoAditivo: response.idCfcTermoAditivo,
          idCfcUnidade: response.idCfcUnidade,
          idTipoTermoAditivoPrestadorServico: response.idTipoTermoAditivoPrestadorServico,
          dataAssinatura: new Date(response.dataAssinatura),
          dataValidade: new Date(response.dataValidade),
          numeroProcesso: response.numeroProcesso,
          justificativa:response.justificativa,
          idArquivo:response.idArquivo,
        });

        this.adicionaArquivo(response.idArquivo,response.arquivo.nome,false);

    });

  }

  inicializarFormularioTermoAditivoPrestador(idCfcUnidade){

    this.formTermoAditivoPrestador = this.fb.group({
      idCfcTermoAditivo:[null],
      idCfcUnidade:[idCfcUnidade],
      idTipoTermoAditivoPrestadorServico: [null,Validators.required],
      dataAssinatura: [null, Validators.required],
      dataValidade: [null, Validators.required],
      numeroProcesso: [null, Validators.required],
      justificativa:[null,Validators.required],
      idArquivo:[],
      arquivos: new FormArray([])
    });

  }

  /**
   * Marks all controls in a form group as touched
   * @param formGroup - The form group to touch
   */
  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  /**
   * Valida o formTermoAditivoPrestador
   */
  private formularioTermoAditivoPrestadorIsValid(){

    this.markFormGroupTouched(this.formTermoAditivoPrestador);
    if (this.arquivos.length === 0) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Documento não inserido!' });
      return false;
    }

    return this.formTermoAditivoPrestador.valid;
  }

  submitFormularioTermoAditivoPrestador(){

    if(this.formularioTermoAditivoPrestadorIsValid()){

      this.cfcService.salvarTermoAditivo(this.formTermoAditivoPrestador.value).subscribe(
        res => {

          this.messageService.add({
            severity: 'success',
            summary: 'Atenção',
            detail: 'Salvo com sucesso!'
          });

          this.router.navigate(['/gerenciar-termo-aditivo-cfc/'+this.formTermoAditivoPrestador.controls['idCfcUnidade'].value]);
      });
    }

  }


  adicionaArquivo(idArquivo, nomeArquivo, isOld: boolean) {
    this.playLoading();

    this.formTermoAditivoPrestador.controls['idArquivo'].setValue(idArquivo);

    const arquivoFormGroup = this.fb.group({
      idArquivo: idArquivo,
      nomeArquivo: nomeArquivo,
      isOld: isOld
    });

    this.arquivos.push(arquivoFormGroup);
    this.stopLoading();

  }

  /**
   * Remove arquivo da tela e o coloca na fila para ser removido pelo banco depois
   * @param arquivo
   */
  removeArquivo(arquivo: AbstractControl) {
    this.arquivosToRemove.push(arquivo);

    const index = this.arquivos.controls.indexOf(arquivo);
    this.arquivos.removeAt(index);
  }

  removeArquivosDoBanco(arquivos: AbstractControl[]) {
    this.playLoading();

    const combined = arquivos.map(a => this.arquivoService.removeArquivo(a.value.idArquivo));

    Observable.combineLatest(combined)
      .finally(() => this.stopLoading())
      .subscribe(
        () => {},
        error => this.gerenciaErro(error)
      );
  }

  uploadError(mensagem) {
    this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: mensagem });
    this.stopLoading();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/cfc/cadastrar-termo-aditivo-cfc/cadastrar-termo-aditivo-cfc.component.ts